import { Button } from 'components/atoms';
import {
  usePostDemoCleanDatabase,
  usePostDemoResetSalesChannelsAndProvider,
  usePostDemoSeedConfiguration,
  usePostDemoSeedData,
} from 'services/settings/individual';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const DemoSettings = () => {
  const seedConfiguration = usePostDemoSeedConfiguration();
  const demoSeedData = usePostDemoSeedData();
  const demoCleanDatabase = usePostDemoCleanDatabase();
  const demoResetSalesChannelsAndProvider = usePostDemoResetSalesChannelsAndProvider();

  const onSeedConfiguration = async () => {
    await seedConfiguration.mutateAsync(undefined, {
      onSuccess: () => window.location.reload(),
    });
  };

  const onDemoSeedData = async () => {
    await demoSeedData.mutateAsync(undefined, {
      onSuccess: () => window.location.reload(),
    });
  };

  const onDemoCleanDatabase = async () => {
    await demoCleanDatabase.mutateAsync(undefined, {
      onSuccess: () => window.location.reload(),
    });
  };

  const onDemoResetSalesChannelsAndProvider = async () => {
    await demoResetSalesChannelsAndProvider.mutateAsync(undefined, {
      onSuccess: () => window.location.reload(),
    });
  };

  return (
    <div className='flex flex-col gap-4 p-24'>
      <Button type='button' onClick={e => onSeedConfiguration()}>
        <Button.Text text={'Seed configuration'} />
      </Button>

      <Button type='button' onClick={e => onDemoSeedData()}>
        <Button.Text text={'Seed data'} />
      </Button>
      <Button
        type='button'
        variant={BUTTON_VARIANT.remove}
        onClick={e => onDemoCleanDatabase()}>
        <Button.Text text={'Clean database'} />
      </Button>

      <Button
        type='button'
        variant={BUTTON_VARIANT.remove}
        onClick={e => onDemoResetSalesChannelsAndProvider()}>
        <Button.Text text={'Reset Sales Channels And Provider'} />
      </Button>
    </div>
  );
};

export default DemoSettings;
